export const LOGO_X = 794;
export const LOGO_Y = 54;
export const PICTURE_X = 729;
export const PICTURE_Y = 207;

export const TITLE_LINE_HEIGHT = 52;
export const TITLE_START_Y = 681;
export const TITLE_FONT = '700 48px "YS Text", sans-serif';

export const TEXT_LINE_HEIGHT = 32;
export const TEXT_START_Y = 809;
export const TEXT_FONT = '500 24px "YS Text", sans-serif';

export const CONFERENCE_LINE_HEIGHT = 28;
export const CONFERENCE_START_Y = 998;
export const CONFERENCE_FONT = '500 24px "YS Text", sans-serif';
